import type { FieldInputProps } from '../types'

export function CheckboxGroupInput({ field, value, onChange, disabled }: FieldInputProps) {
  const selected: string[] = Array.isArray(value) ? value.map(String) : []
  const toggle = (v: string) => {
    const next = selected.includes(v) ? selected.filter(x => x !== v) : [...selected, v]
    onChange(next)
  }
  return (
    <div id={`field-${field.fieldCode}`} className="flex flex-col gap-1">
      {field.options.map(o => (
        <label key={o.value} className="flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            disabled={disabled}
            checked={selected.includes(o.value)}
            onChange={() => toggle(o.value)}
          />
          <span>{o.labelPl}</span>
        </label>
      ))}
    </div>
  )
}
